import GasPumpRim from './GasPumpRim';

export default GasPumpRim;
